// extracted by mini-css-extract-plugin
module.exports = {"btn":"_3x7vn","list":"niGQ7","header":"L6pqd","rowsOutside":"h7sfD","rows":"qc-lj","row":"yn4zw","charts":"_3pYXa","label":"_1uoBp","star":"_2i2rE","grid":"L0ff4"};